const ROOT_DOMAIN = process.env.REACT_APP_ROOT_DOMAIN || "adukkumadi.in";
const DOMAIN_STORAGE_KEY = "adminDomain";
const SUBDOMAIN_STORAGE_KEY = "adminSubdomain";

export { ROOT_DOMAIN };

export function normalizeSubdomain(raw) {
  let s = String(raw || "").trim().toLowerCase();
  s = s.replace(/^https?:\/\//, "");
  s = s.split("/")[0] || "";
  if (s.endsWith(`.${ROOT_DOMAIN}`)) {
    s = s.slice(0, -(ROOT_DOMAIN.length + 1));
  }
  s = s.replace(/\s+/g, "").replace(/^\.+|\.+$/g, "");
  return s;
}

function pickDomainFields(source) {
  if (!source || typeof source !== "object") {
    return { subdomain: "", domain: "" };
  }
  const subdomain = String(source.subdomain || "").trim().toLowerCase();
  const domain = String(source.domain || "").trim().toLowerCase();
  return { subdomain, domain };
}

export function persistInviteDomainFromProfile(profile) {
  const { subdomain, domain } = pickDomainFields(profile);
  try {
    if (domain) localStorage.setItem(DOMAIN_STORAGE_KEY, domain);
    if (subdomain) localStorage.setItem(SUBDOMAIN_STORAGE_KEY, subdomain);
  } catch {
    /* ignore */
  }
  return { subdomain, domain };
}

export function parseHostSubdomain(hostname) {
  const host = String(hostname || "").toLowerCase().split(":")[0];
  if (!host || host === "localhost" || host === "127.0.0.1") return "";
  if (host === ROOT_DOMAIN || host === `www.${ROOT_DOMAIN}`) return "";
  const suffix = `.${ROOT_DOMAIN}`;
  if (!host.endsWith(suffix)) return "";
  const prefix = host.slice(0, -suffix.length);
  if (!prefix || prefix.includes(".")) return "";
  return prefix;
}

/** Resolve admin tenant-invite host (subdomain.adukkumadi.in). */
export function getInviteDomainContext() {
  let subdomain = "";
  let domain = "";

  try {
    subdomain = String(localStorage.getItem(SUBDOMAIN_STORAGE_KEY) || "").trim().toLowerCase();
    domain = String(localStorage.getItem(DOMAIN_STORAGE_KEY) || "").trim().toLowerCase();
  } catch {
    /* ignore */
  }

  if (typeof window !== "undefined") {
    const fromHost = parseHostSubdomain(window.location.hostname);
    if (fromHost) {
      subdomain = fromHost;
      domain = `${fromHost}.${ROOT_DOMAIN}`;
    }
  }

  if (!domain && subdomain) {
    domain = `${subdomain}.${ROOT_DOMAIN}`;
  }
  if (domain && !subdomain && domain.endsWith(`.${ROOT_DOMAIN}`)) {
    subdomain = domain.slice(0, -(ROOT_DOMAIN.length + 1));
  }

  const inviteBaseUrl = domain ? `https://${domain}` : `https://${ROOT_DOMAIN}`;

  return {
    subdomain,
    domain,
    inviteBaseUrl,
    rootDomain: ROOT_DOMAIN,
  };
}

export async function ensureAdminInviteDomainFromApi(userId) {
  const API_BASE_URL = process.env.REACT_APP_API_URL;
  const id = String(userId || "").trim();
  if (!API_BASE_URL || !id) return getInviteDomainContext();

  const existing = getInviteDomainContext();
  if (existing.domain) return existing;

  try {
    const axios = (await import("axios")).default;
    const response = await axios.post(API_BASE_URL, {
      action: "getProfile",
      userId: id,
    });
    const data = response?.data;
    if (!(data?.status === "success" || data?.success === true)) {
      return existing;
    }

    const profile =
      data.profile ||
      data.user ||
      data.data ||
      data.result ||
      data;
    persistInviteDomainFromProfile(profile);
    return getInviteDomainContext();
  } catch {
    return existing;
  }
}
